export default () => ({
  id            : null,
  name          : null,
  uuid          : null,
  username      : null,
  password      : null,
  email         : null,
  type          : null,
  photo         : null,
  timezone      : null,
  languageId    : null,
  accessibility : {
    darkThemeEnabled    : false,
    fontSizeEnabled     : false,
    signLanguageEnabled : false
  },

  // deprecated
  accessibilities       : null,
  dark                  : true,
  temporaryPassword     : false,
  availableApplications : [],

  // v3
  contexts       : [],
  currentContext : null,
  permissions    : {},
  amr            : [] // Authentication Methods Reference
});
